import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
// import Processing from "../../components/processing/processing";
import { useLocation } from "react-router-dom";
import { API } from "../../api/api";
import constants from '../../utils/contants';
import { CountryDropdown } from 'react-country-region-selector';

const LicenseTab = () => {

    const [isEditable, setIsEditable] = useState(false);
    const [buttonValue, setButtonValue] = useState("Edit");
    const { state } = useLocation();
    const { driver } = state;

    useEffect(() => {
        getUserData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getUserData = () => {
        // setLoading(true);
        formik.setFieldValue("DL_number", driver?.driving_license?.DL_number);
        formik.setFieldValue("verified", driver?.driving_license?.is_completed_driving_license_process);
        formik.setFieldValue("DL_country", driver?.driving_license?.DL_country);
        formik.setFieldValue("DL_expiration", driver?.driving_license?.DL_expiration);
        // setLoading(false);
    };

    const validationSchema = Yup.object().shape({
        DL_number: Yup.string().required("Please Enter Username"),
        verified: Yup.string().required("Please Enter Username"),
        DL_country: Yup.string().required("Please Enter email"),
        DL_expiration: Yup.string().required("Please Enter email"),
    });

    const formik = useFormik({
        initialValues: {
            DL_number: "",
            verified: "",
            DL_country: "",
            DL_expiration: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            const body = {
                // id: driver?._id,
                driving_license: {
                    DL_number: values?.DL_number,
                    DL_country: values?.DL_country,
                    DL_expiration: values?.DL_expiration,
                    is_completed_driving_license_process: values?.verified,
                }
            };
            API(`update-driver/${driver?._id}`, "put", body, localStorage.getItem(constants.TOKEN))
                .then((res) => {
                    toast.success("Driver Details updated successfully ✅", {
                        position: toast.POSITION.TOP_RIGHT,
                        className: "bg-success text-white",
                    });
                    // navigate("/manage-driver");
                })
                .catch((error) => {
                    toast.error("Error while updating Driver Details", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    console.log("error: ", error);
                });
        },
    });

    const enableEditing = () => {
        setIsEditable(true);
        setButtonValue("Update");
    };



    return (
        <>
            <hr className="mt-4" />
            <div className="advice_form text-black select_visible">
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Verified</label>
                    <select
                        type="text"
                        name="verified"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black"
                        // {...formik.getFieldProps("username")}
                        value={formik.values.verified}
                        onChange={(e) => {
                            formik.setFieldValue("verified", e.target.value?.trimStart())
                        }}
                    >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                    {formik.touched.verified && formik.errors.verified && (
                        <div className="text-danger">{formik.errors.verified}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Number</label>
                    <input
                        type="text"
                        name="DL_number"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black"
                        // {...formik.getFieldProps("username")}
                        value={formik.values.DL_number}
                        onChange={(e) => {
                            formik.setFieldValue("DL_number", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.DL_number && formik.errors.DL_number && (
                        <div className="text-danger">{formik.errors.DL_number}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Country</label>
                    <CountryDropdown
                    disabled={isEditable ? false : true}
                    className="form form-control bg-transparent text-black type_password"
                        value={formik.values.DL_country}
                        onChange={(value) => {
                            formik.setFieldValue("DL_country", value)
                        }} />
                    {formik.touched.driving_license?.DL_country && formik.errors.driving_license?.DL_country && (
                        <div className="text-danger">{formik.errors.driving_license?.DL_country}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Expiration date</label>
                    <input
                        type="text"
                        name="DL_expiration"
                        disabled
                        className="form form-control bg-transparent text-black type_password"
                        // {...formik.getFieldProps("email")}
                        value={formik.values.DL_expiration}
                        onChange={(e) => {
                            formik.setFieldValue("DL_expiration", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.driving_license?.DL_expiration && formik.errors.driving_license?.DL_expiration && (
                        <div className="text-danger">{formik.errors.driving_license?.DL_expiration}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Photo</label>
                    <input
                        type="text"
                        name="email"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black type_password"
                        // {...formik.getFieldProps("email")}
                        value={formik.values.email}
                        onChange={(e) => {
                            formik.setFieldValue("email", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.email && formik.errors.email && (
                        <div className="text-danger">{formik.errors.email}</div>
                    )}
                </div>

                <div className="d-flex mt-5 justify-content-end gap-4">
                    <button
                        type="button"
                        className="form_button btn advice__category"
                        onClick={() => {
                            window.history.back();
                        }}
                    >
                        Back
                    </button>
                    <button
                        type="button"
                        className="form_button btn advice__category"
                        disabled={
                            buttonValue === "Update" &&
                            formik.values.DL_number === driver?.driving_license?.DL_expiration &&
                            formik.values.DL_country === driver?.driving_license?.DL_country &&
                            formik.values.DL_country === driver?.driving_license?.is_completed_driving_license_process &&
                            formik.values.lastname === driver?.driving_license?.DL_number
                        }
                        onClick={
                            buttonValue === "Update" ? formik.handleSubmit : enableEditing
                        }
                    >
                        {buttonValue}
                    </button>
                </div>
            </div>
        </>
    )
}

export default LicenseTab